import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { Employee360Listing } from './Pages'

export const Employee360Routes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={Employee360Listing} />
    </Fragment>
)